import { Textarea } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  initialValue: string;
  placeholder?: string;
  onSave: (value: string) => void;
  isDisabled?: boolean;
}

/**
 * Autosaving narrative input: edits are held locally and flushed to the draft on
 * blur, only when the value actually changed since it was last persisted.
 */
export const NarrativeField = ({ initialValue, placeholder, onSave, isDisabled = false }: Props) => {
  const { t } = useTranslation();
  const [value, setValue] = useState(initialValue);
  const [savedValue, setSavedValue] = useState(initialValue);

  useEffect(() => {
    setValue(initialValue);
    setSavedValue(initialValue);
  }, [initialValue]);

  const handleBlur = () => {
    if (value === savedValue) return;
    setSavedValue(value);
    onSave(value);
  };

  return (
    <Textarea
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={handleBlur}
      isDisabled={isDisabled}
      placeholder={placeholder ?? t("Write your assessment…") ?? undefined}
      bg="smBackground"
      borderColor="smBorder"
      rounded="md"
      minH="120px"
      fontSize="sm"
    />
  );
};
